(function () {
  var cfg = window.MCH || {};
  var CART_KEY = 'mch_sf_cart_id';
  var CART_CACHE_KEY = 'mch_sf_cart_cache';
  var SF_API = 'https://' + (cfg.shop || '') + '/api/' + (cfg.sfApiVersion || '2026-07') + '/graphql.json';

  // ponytail: dev - fixed CZK/CZ; header switcher hidden until SK market
  var LOCALE = { currency: 'CZK', country: 'CZ', language: 'CS', suffix: ' Kč' };

  function getLocale() {
    return LOCALE;
  }

  function formatMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(0);
    var withSpaces = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return withSpaces + getLocale().suffix;
  }

  function formatMoneyDecimals(cents) {
    var n = Math.round(cents) / 100;
    var parts = n.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return whole + ',' + parts[1] + getLocale().suffix;
  }

  function formatMajor(amount) {
    var n = Math.round(parseFloat(amount) || 0);
    var withSpaces = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return withSpaces + getLocale().suffix;
  }

  function root() {
    return cfg.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function karibuReady() {
    return !!(cfg.karibuApiBase && cfg.karibuTenant && cfg.storefrontToken);
  }

  var toastTimer;
  var toastHideTimer;
  function hideToast() {
    var root = document.getElementById('mch-toast');
    if (!root) return;
    clearTimeout(toastTimer);
    clearTimeout(toastHideTimer);
    root.classList.remove('mch-toast--visible');
    root.setAttribute('aria-hidden', 'true');
    toastHideTimer = setTimeout(function () { root.hidden = true; }, 350);
  }

  function showToast(msg) {
    var root = document.getElementById('mch-toast');
    if (!root) {
      root = document.createElement('div');
      root.id = 'mch-toast';
      root.setAttribute('role', 'status');
      root.setAttribute('aria-live', 'polite');
      root.innerHTML = '<div class="mch-toast__box"></div>';
      document.body.appendChild(root);
    }
    root.querySelector('.mch-toast__box').textContent = msg;
    clearTimeout(toastTimer);
    clearTimeout(toastHideTimer);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    root.classList.remove('mch-toast--visible');
    requestAnimationFrame(function () {
      root.classList.add('mch-toast--visible');
    });
    toastTimer = setTimeout(hideToast, 3000);
  }

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || '').trim() : '';
  }

  /* - Storefront Cart (Karibu) - */
  function sf(query, variables) {
    var locale = getLocale();
    var vars = Object.assign({
      country: locale.country,
      language: locale.language,
      pricingProfileNamespace: cfg.pricingProfileNamespace || ''
    }, variables || {});
    return fetch(SF_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': cfg.storefrontToken
      },
      body: JSON.stringify({ query: query, variables: vars })
    }).then(function (r) { return r.json(); });
  }

  function getCartId() {
    try { return localStorage.getItem(CART_KEY) || ''; } catch (e) { return ''; }
  }

  function clearCartCache() {
    try { sessionStorage.removeItem(CART_CACHE_KEY); } catch (e) { /* ignore */ }
  }

  function cacheCart(cart) {
    if (!cart || !lineNodes(cart).length) {
      clearCartCache();
      return;
    }
    try { sessionStorage.setItem(CART_CACHE_KEY, JSON.stringify(cart)); } catch (e) { /* ignore */ }
  }

  function readCartCache() {
    try {
      var raw = sessionStorage.getItem(CART_CACHE_KEY);
      if (!raw) return null;
      var cart = JSON.parse(raw);
      if (!cart || cart.id !== getCartId()) return null;
      return cart;
    } catch (e) { return null; }
  }

  function paintCartBadge(has) {
    has = !!has;
    document.documentElement.classList.toggle('mch-has-cart', has);
    var link = document.querySelector('.site-header__cart');
    if (!link) return;
    link.classList.toggle('is-full', has);
    var mark = link.querySelector('.site-header__cart-mark');
    if (mark) mark.classList.toggle('is-full', has);
  }

  function setCartId(id) {
    try {
      if (id) {
        localStorage.setItem(CART_KEY, id);
      } else {
        localStorage.removeItem(CART_KEY);
        clearCartCache();
        paintCartBadge(false);
      }
    } catch (e) { /* ignore */ }
  }

  // Keep localStorage id, session cache, and header class in sync
  function commitCart(cart) {
    if (!cart || !lineNodes(cart).length) {
      setCartId('');
      return null;
    }
    setCartId(cart.id);
    cacheCart(cart);
    updateCartBadge(cart);
    return cart;
  }

  // lineLevelOnly:false = line's own discounts + prorated cart-wide share (API 2026-07+)
  // cost.subtotalAmount = undiscounted line; amountPerQuantity is post line-level discount
  var CART_QUERY = [
    'id',
    'totalQuantity',
    'cost{subtotalAmount{amount currencyCode} totalAmount{amount currencyCode}}',
    'discountCodes{code applicable}',
    'lines(first:50){edges{node{',
    'id quantity',
    'attributes{key value}',
    'discountAllocations(lineLevelOnly:false){',
    '__typename targetType',
    'discountedAmount{amount currencyCode}',
    '...on CartAutomaticDiscountAllocation{title}',
    '...on CartCodeDiscountAllocation{code}',
    '...on CartCustomDiscountAllocation{title}',
    '}',
    'cost{amountPerQuantity{amount currencyCode} subtotalAmount{amount currencyCode} totalAmount{amount}}',
    'merchandise{...on ProductVariant{',
    'id title image{url} price{amount currencyCode}',
    'selectedOptions{name value}',
    'product{',
    'id title handle',
    'options{name values}',
    'variants(first:100){edges{node{id title availableForSale selectedOptions{name value} image{url} price{amount}}}}',
    '}',
    '}',
    '}',
    '}}}'
  ].join(' ');

  function sfErrors(res) {
    if (res && res.errors && res.errors.length) {
      return res.errors.map(function (e) { return e.message; }).join('; ');
    }
    return '';
  }

  function fetchCart(id) {
    return sf(
      'query($id:ID!,$country:CountryCode!,$language:LanguageCode!)@inContext(country:$country,language:$language){cart(id:$id){' + CART_QUERY + '}}',
      { id: id }
    ).then(function (res) {
      return res.data && res.data.cart;
    });
  }

  function checkCartState(cartId) {
    var base = String(cfg.karibuApiBase || '').replace(/\/$/, '');
    if (!base || !cfg.karibuTenant || !cartId) return Promise.resolve(null);
    return fetch(base + '/v1/tenants/' + encodeURIComponent(cfg.karibuTenant) + '/cart-state', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ cartId: cartId })
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .catch(function () { return null; });
  }

  function forgetIfEmpty(cart) {
    return commitCart(cart);
  }

  function ensureCart() {
    var id = getCartId();
    if (!id) return Promise.resolve(null);

    // parallel: was sequential Karibu→Shopify and doubled wait for badge/cart paint
    return Promise.all([checkCartState(id), fetchCart(id)]).then(function (pair) {
      if (pair[0] && pair[0].state === 'DRAFT_CREATED') {
        setCartId('');
        return null;
      }
      return forgetIfEmpty(pair[1]);
    });
  }

  function cartCreate(lines) {
    var input = {
      lines: lines,
      buyerIdentity: { countryCode: getLocale().country }
    };
    return sf(
      'mutation($input:CartInput,$country:CountryCode!,$language:LanguageCode!)@inContext(country:$country,language:$language){cartCreate(input:$input){cart{' + CART_QUERY + '} userErrors{message}}}',
      { input: input }
    ).then(function (res) {
      var gqlErr = sfErrors(res);
      if (gqlErr) throw new Error(gqlErr);
      var payload = res.data && res.data.cartCreate;
      if (!payload || (payload.userErrors && payload.userErrors.length)) {
        throw new Error((payload && payload.userErrors[0] && payload.userErrors[0].message) || 'cartCreate failed');
      }
      return commitCart(payload.cart);
    });
  }

  function cartLinesAdd(cartId, lines) {
    return sf(
      'mutation($cartId:ID!,$lines:[CartLineInput!]!,$country:CountryCode!,$language:LanguageCode!)@inContext(country:$country,language:$language){cartLinesAdd(cartId:$cartId,lines:$lines){cart{' + CART_QUERY + '} userErrors{message}}}',
      { cartId: cartId, lines: lines }
    ).then(function (res) {
      var gqlErr = sfErrors(res);
      if (gqlErr) throw new Error(gqlErr);
      var payload = res.data && res.data.cartLinesAdd;
      if (!payload || (payload.userErrors && payload.userErrors.length)) {
        throw new Error((payload && payload.userErrors[0] && payload.userErrors[0].message) || 'cartLinesAdd failed');
      }
      return commitCart(payload.cart);
    });
  }

  function cartLinesUpdate(cartId, lines) {
    return sf(
      'mutation($cartId:ID!,$lines:[CartLineUpdateInput!]!,$country:CountryCode!,$language:LanguageCode!)@inContext(country:$country,language:$language){cartLinesUpdate(cartId:$cartId,lines:$lines){cart{' + CART_QUERY + '} userErrors{message}}}',
      { cartId: cartId, lines: lines }
    ).then(function (res) {
      var gqlErr = sfErrors(res);
      if (gqlErr) throw new Error(gqlErr);
      var payload = res.data && res.data.cartLinesUpdate;
      if (!payload || (payload.userErrors && payload.userErrors.length)) {
        throw new Error((payload && payload.userErrors[0] && payload.userErrors[0].message) || 'cartLinesUpdate failed');
      }
      return forgetIfEmpty(payload.cart);
    });
  }

  // Shopify replaces the whole code set - callers must pass the full list
  function cartDiscountCodesUpdate(cartId, discountCodes) {
    return sf(
      'mutation($cartId:ID!,$discountCodes:[String!]!,$country:CountryCode!,$language:LanguageCode!)@inContext(country:$country,language:$language){cartDiscountCodesUpdate(cartId:$cartId,discountCodes:$discountCodes){cart{' + CART_QUERY + '} userErrors{message} warnings{code message}}}',
      { cartId: cartId, discountCodes: discountCodes }
    ).then(function (res) {
      var gqlErr = sfErrors(res);
      if (gqlErr) throw new Error(gqlErr);
      var payload = res.data && res.data.cartDiscountCodesUpdate;
      if (!payload || (payload.userErrors && payload.userErrors.length)) {
        throw new Error((payload && payload.userErrors[0] && payload.userErrors[0].message) || 'cartDiscountCodesUpdate failed');
      }
      return { cart: commitCart(payload.cart), warnings: payload.warnings || [] };
    });
  }

  function variantGid(id) {
    return 'gid://shopify/ProductVariant/' + id;
  }

  function productGid(id) {
    return 'gid://shopify/Product/' + id;
  }

  function lineNodes(cart) {
    return ((cart && cart.lines && cart.lines.edges) || []).map(function (e) { return e.node; });
  }

  function attr(line, key) {
    var list = line.attributes || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].key === key) return list[i].value;
    }
    return '';
  }

  // Undiscounted unit price. Not amountPerQuantity - that one is after line-level discounts.
  function baseUnit(line) {
    var sub = parseFloat(line.cost && line.cost.subtotalAmount && line.cost.subtotalAmount.amount);
    if (!isNaN(sub) && line.quantity > 0) return sub / line.quantity;
    return parseFloat(line.cost && line.cost.amountPerQuantity && line.cost.amountPerQuantity.amount) || 0;
  }

  function chosenUnit(line) {
    var raw = attr(line, 'karibu_chosen_price');
    if (raw === '') return baseUnit(line);
    return parseFloat(raw) || baseUnit(line);
  }

  function moneyFromAmount(amount) {
    return formatMoney(Math.round(parseFloat(amount) * 100));
  }

  // Shopify allocations are the authority (line + prorated cart-wide when lineLevelOnly:false)
  function lineItemAllocations(line) {
    return (line.discountAllocations || []).filter(function (a) {
      return a.targetType === 'LINE_ITEM';
    });
  }

  function allocationLabel(a) {
    return a.code || a.title || 'Sleva';
  }

  function lineDiscountAmount(line) {
    return lineItemAllocations(line).reduce(function (sum, a) {
      return sum + (parseFloat(a.discountedAmount && a.discountedAmount.amount) || 0);
    }, 0);
  }

  function discountRowsFromLines(lines) {
    var byLabel = {};
    var order = [];
    lines.forEach(function (line) {
      lineItemAllocations(line).forEach(function (a) {
        var label = allocationLabel(a);
        var amt = parseFloat(a.discountedAmount && a.discountedAmount.amount) || 0;
        if (!byLabel[label]) {
          byLabel[label] = 0;
          order.push(label);
        }
        byLabel[label] += amt;
      });
    });
    return order.map(function (label) {
      return { label: label, amount: byLabel[label] };
    });
  }

  function appliedDiscountCodes(cart) {
    return ((cart && cart.discountCodes) || []).map(function (d) { return d.code; });
  }

  function discountWarning(warnings) {
    return (warnings || []).find(function (w) {
      return String(w.code || '').indexOf('DISCOUNT_') === 0;
    }) || null;
  }

  function escapeText(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function updateCartBadge(cart) {
    var n = 0;
    lineNodes(cart).forEach(function (line) { n += line.quantity; });
    paintCartBadge(n > 0);
  }

  // Sync header tile if head already set html.mch-has-cart from localStorage
  if (getCartId()) paintCartBadge(true);

  function addMerchKaribu(variantId, chosenKc) {
    var line = {
      merchandiseId: variantGid(variantId),
      quantity: 1,
      attributes: [{ key: 'karibu_chosen_price', value: Number(chosenKc).toFixed(2) }]
    };
    var cartId = getCartId();
    if (!cartId) return cartCreate([line]);
    return cartLinesAdd(cartId, [line]);
  }

  function cellText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function transposeSizeTable(table) {
    var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
    var parsed = [];

    rows.forEach(function (tr) {
      var cells = Array.prototype.slice.call(tr.querySelectorAll('th, td'));
      if (!cells.length) return;
      if (cells.length === 1 && (cells[0].querySelector('.size-guide-title') || /tabulka velikost/i.test(cellText(cells[0])))) {
        return;
      }
      parsed.push(cells.map(cellText));
    });

    if (parsed.length < 2) return table;

    var footer = null;
    var measurements = [];
    parsed.slice(1).forEach(function (row) {
      if (row.length === 1 || (row[0] && /tolerance/i.test(row[0]) && !row.slice(1).some(Boolean))) {
        footer = row[0];
        return;
      }
      measurements.push(row);
    });

    if (!measurements.length) return table;

    var sizes = parsed[0].slice(1).filter(Boolean);
    var labels = measurements.map(function (row) { return row[0]; });
    var values = measurements.map(function (row) { return row.slice(1); });

    var out = document.createElement('table');
    var thead = document.createElement('thead');
    var headTr = document.createElement('tr');
    var corner = document.createElement('th');
    corner.className = 'first-column';
    headTr.appendChild(corner);
    labels.forEach(function (label) {
      var th = document.createElement('th');
      th.textContent = label;
      headTr.appendChild(th);
    });
    thead.appendChild(headTr);
    out.appendChild(thead);

    var tbody = document.createElement('tbody');
    sizes.forEach(function (size, i) {
      var tr = document.createElement('tr');
      if (i % 2 === 1) tr.className = 'even-row';
      var sizeTd = document.createElement('td');
      sizeTd.className = 'first-column';
      sizeTd.textContent = size;
      tr.appendChild(sizeTd);
      values.forEach(function (rowVals) {
        var td = document.createElement('td');
        td.textContent = rowVals[i] || '';
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    out.appendChild(tbody);

    if (footer) {
      var tfoot = document.createElement('tfoot');
      var footTr = document.createElement('tr');
      footTr.className = 'even-row';
      var footTd = document.createElement('td');
      footTd.colSpan = labels.length + 1;
      footTd.className = 'just-line';
      footTd.textContent = footer;
      footTr.appendChild(footTd);
      tfoot.appendChild(footTr);
      out.appendChild(tfoot);
    }

    return out;
  }

  function moveChildren(from, to) {
    while (from.firstChild) to.appendChild(from.firstChild);
  }

  function fillSection(body, section, tag) {
    if (!tag) return false;
    moveChildren(tag, body);
    tag.remove();
    if (body.textContent.trim()) section.hidden = false;
    return true;
  }

  // ponytail: prod titles use "pánské"/"dámské"; data-fit uses panske/damske
  function fitFromText(text) {
    var t = String(text || '').toLowerCase();
    if (/d[aá]msk/.test(t)) return 'damske';
    if (/p[aá]nsk/.test(t)) return 'panske';
    return '';
  }

  function appendSizeTable(sizeTable, fitHint) {
    var sizeBody = document.querySelector('[data-product-size-table-body]');
    var sizeSection = document.querySelector('[data-product-size-table]');
    if (!sizeTable || !sizeBody) return false;
    var titleEl = sizeTable.querySelector('.size-guide-title');
    var fit = fitHint || fitFromText(titleEl && titleEl.textContent) || fitFromText(sizeTable.getAttribute('data-fit'));
    var out = transposeSizeTable(sizeTable);
    if (fit) out.setAttribute('data-fit', fit);
    sizeBody.appendChild(out);
    sizeTable.remove();
    sizeSection.hidden = false;
    return true;
  }

  function renderSizeTablesFrom(scope) {
    var tags = scope.querySelectorAll ? scope.querySelectorAll('product-size-table') : [];
    if (tags.length) {
      var ok = false;
      Array.prototype.forEach.call(tags, function (tag) {
        var table = tag.querySelector('#size-guide, table[id="size-guide"], table');
        if (table && appendSizeTable(table, tag.getAttribute('data-fit') || '')) ok = true;
        tag.remove();
      });
      return ok;
    }
    var tables = scope.querySelectorAll('#size-guide, table[id="size-guide"]');
    if (!tables.length) {
      var one = scope.querySelector('table');
      if (one) tables = [one];
    }
    if (!tables.length) return false;
    Array.prototype.forEach.call(tables, function (table) { appendSizeTable(table, ''); });
    return true;
  }

  function selectedCutFit(optionSelects) {
    var cut = '';
    Array.prototype.forEach.call(optionSelects || [], function (sel) {
      var f = fitFromText(sel.value);
      if (f) cut = f;
    });
    return cut;
  }

  function selectedColor(optionSelects) {
    var color = '';
    Array.prototype.forEach.call(optionSelects || [], function (sel) {
      var n = String(sel.getAttribute('data-option-name') || '').toLowerCase();
      if (n === 'barva' || n === 'color' || n === 'colour') color = sel.value;
    });
    return color;
  }

  function gallerySlideHidden(slide, cut, color) {
    var fit = slide.getAttribute('data-fit');
    var slideColor = String(slide.getAttribute('data-color') || '').toLowerCase();
    var wantColor = String(color || '').toLowerCase();
    if (fit && cut && fit !== cut) return true;
    if (slideColor && wantColor && slideColor !== wantColor) return true;
    return false;
  }

  function pickPreviewSlide(slides, mediaId) {
    if (!mediaId) return null;
    var want = String(mediaId);
    return Array.prototype.find.call(slides, function (s) {
      return !s.hidden && String(s.getAttribute('data-media-id')) === want;
    }) || null;
  }

  function syncCutFit(cut, mediaId, color) {
    var tables = document.querySelectorAll('[data-product-size-table-body] table[data-fit]');
    if (tables.length > 1 && cut) {
      Array.prototype.forEach.call(tables, function (t) {
        t.hidden = t.getAttribute('data-fit') !== cut;
      });
    } else {
      Array.prototype.forEach.call(tables, function (t) { t.hidden = false; });
    }
    var heading = document.querySelector('[data-product-size-table] h2');
    if (heading) {
      var base = heading.getAttribute('data-base-label') || heading.textContent.trim();
      heading.setAttribute('data-base-label', base);
      if (cut === 'panske') heading.textContent = base + ' - Pánské';
      else if (cut === 'damske') heading.textContent = base + ' - Dámské';
      else heading.textContent = base;
    }

    // Gallery: filter by cut + color. Extra views (back) stay if they share that color.
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.product-page__gallery-slide');
    Array.prototype.forEach.call(slides, function (s) {
      s.hidden = gallerySlideHidden(s, cut, color);
    });
    var firstVisible = Array.prototype.find.call(slides, function (s) { return !s.hidden; });
    // ponytail: if cut filter hides everything, show all rather than an empty gallery
    if (!firstVisible) {
      Array.prototype.forEach.call(slides, function (s) { s.hidden = false; });
      firstVisible = slides[0] || null;
    }
    var preview = pickPreviewSlide(slides, mediaId);
    if (preview) {
      if (firstVisible && preview !== firstVisible) gallery.insertBefore(preview, firstVisible);
      firstVisible = preview;
    }
    var wrap = gallery.parentElement;
    var dots = wrap ? wrap.querySelectorAll('[data-gallery-dot]') : [];
    Array.prototype.forEach.call(dots, function (dot) {
      var i = parseInt(dot.getAttribute('data-gallery-dot'), 10);
      var slide = slides[i];
      var on = slide && !slide.hidden;
      dot.hidden = !on;
      if (on && slide === firstVisible) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.classList.remove('is-active');
        dot.setAttribute('aria-selected', 'false');
      }
    });
    if (firstVisible && gallery.scrollWidth > gallery.clientWidth) {
      firstVisible.scrollIntoView({ inline: 'start', block: 'nearest' });
    }
  }

  function splitProductDescription() {
    var staging = document.querySelector('[data-product-description]');
    var intro = document.querySelector('[data-product-intro]');
    if (!staging || !intro) return;

    var wrap = document.createElement('div');
    wrap.innerHTML = staging.innerHTML;

    var introTag = wrap.querySelector('product-intro');
    var sizeTag = wrap.querySelector('product-size-table');
    var detailsTag = wrap.querySelector('product-details');
    var detailsBody = document.querySelector('[data-product-details-body]');
    var detailsSection = document.querySelector('[data-product-details]');

    if (introTag || sizeTag || detailsTag) {
      if (introTag) intro.innerHTML = introTag.innerHTML.trim();
      else intro.innerHTML = '';
      introTag && introTag.remove();

      renderSizeTablesFrom(wrap);

      if (detailsTag) fillSection(detailsBody, detailsSection, detailsTag);
      staging.remove();
      return;
    }

    // ponytail: legacy mixed content - tags stripped by Shopify or old format
    var sizeTables = wrap.querySelectorAll('#size-guide, table[id="size-guide"]');
    var firstTable = sizeTables[0];
    var introWrap = document.createElement('div');

    if (!wrap.querySelector('product-details') && !firstTable) {
      intro.innerHTML = wrap.innerHTML.trim();
      staging.remove();
      return;
    }

    var legacyDetails = wrap.querySelector('product-details');
    if (legacyDetails) {
      while (wrap.firstChild && wrap.firstChild !== legacyDetails) {
        introWrap.appendChild(wrap.firstChild);
      }
    } else if (firstTable) {
      while (wrap.firstChild && wrap.firstChild !== firstTable) {
        introWrap.appendChild(wrap.firstChild);
      }
    }

    if (sizeTables.length) {
      Array.prototype.forEach.call(sizeTables, function (table) { appendSizeTable(table, ''); });
    }

    if (legacyDetails) {
      while (legacyDetails.firstChild) detailsBody.appendChild(legacyDetails.firstChild);
      legacyDetails.remove();
    } else {
      while (wrap.firstChild) detailsBody.appendChild(wrap.firstChild);
    }

    if (detailsBody.textContent.trim()) detailsSection.hidden = false;
    intro.innerHTML = introWrap.innerHTML.trim();
    staging.remove();
  }
  splitProductDescription();

  /* - Product form - */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var mapEl = form.querySelector('[data-variant-map]');
    if (!mapEl) return;
    var variants = JSON.parse(mapEl.textContent);
    var mediaMapEl = form.querySelector('[data-variant-media]');
    var mediaByVariant = {};
    if (mediaMapEl) {
      try { mediaByVariant = JSON.parse(mediaMapEl.textContent); } catch (e) { mediaByVariant = {}; }
    }
    var idInput = form.querySelector('[name="id"]');
    var totalEl = form.querySelector('[data-total-price]');
    var donationEl = form.querySelector('[data-donation-amount]');
    var taxEl = form.querySelector('[data-tax-amount]');
    var merchEl = form.querySelector('[data-merch-amount]');
    var tiersEl = form.querySelector('[data-price-tiers]');
    var merchPrice = parseInt(form.dataset.merchPrice || '89900', 10);
    var donationVariantId = form.dataset.donationVariant || '';
    var productId = form.dataset.productId || '';
    var hasPricingProfile = form.dataset.hasPricingProfile === 'true';
    var priceButtons = form.querySelectorAll('[data-price-btn]');
    var slider = form.querySelector('[data-price-slider]');
    var optionSelects = form.querySelectorAll('[data-option-select]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var totalKc = Math.round(merchPrice / 100);
    var tierMax = 0;
    var profileAmounts = [];
    if (slider) {
      totalKc = parseInt(slider.value, 10) || totalKc;
      tierMax = parseInt(slider.max, 10) || 0;
    }
    var maxTotal = tierMax || (slider ? (parseInt(slider.max, 10) || totalKc) : totalKc);
    var sfPriceByVariant = {};

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return String(o) === String(opts[i]); });
      });
    }

    function selectedOptions() {
      var opts = [];
      optionSelects.forEach(function (sel) {
        opts[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
      });
      return opts;
    }

    // Disable option values with no matching variant for the other selected axes
    // (e.g. Blue has no 5XL). OOS variants stay selectable; ATC handles available.
    function pruneOptions() {
      if (!optionSelects.length) return;
      var selected = selectedOptions();
      optionSelects.forEach(function (sel) {
        var idx = parseInt(sel.dataset.optionIndex, 10);
        Array.prototype.forEach.call(sel.options, function (opt) {
          var exists = variants.some(function (v) {
            if (String(v.options[idx]) !== String(opt.value)) return false;
            return selected.every(function (val, i) {
              if (i === idx) return true;
              return String(v.options[i]) === String(val);
            });
          });
          opt.disabled = !exists;
        });
        if (sel.selectedOptions[0] && sel.selectedOptions[0].disabled) {
          var first = Array.prototype.find.call(sel.options, function (o) { return !o.disabled; });
          if (first) sel.value = first.value;
        }
      });
    }

    function syncAddButton(variant) {
      if (!addBtn) return;
      if (!karibuReady()) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.nokaribuLabel || 'Nákup není dostupný';
        return;
      }
      if (!variant || variant.available === false) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.soldoutLabel || 'Produkt nedostupný';
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = addBtn.dataset.addLabel || 'Přidat do košíku';
    }

    function bindPriceButtons() {
      priceButtons = form.querySelectorAll('[data-price-btn]');
      priceButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          totalKc = parseInt(btn.dataset.priceBtn, 10);
          syncTotal();
        });
      });
    }

    function hideSupportBox() {
      var box = form.querySelector('.support-box');
      if (box) box.hidden = true;
      hasPricingProfile = false;
      totalKc = Math.round(merchPrice / 100);
      syncTotal();
    }

    function renderTiers(amounts, preferSuggested) {
      if (!tiersEl || !amounts || !amounts.length) return;
      // Keep the full locale-currency list so a cheaper variant can re-admit prices
      // that were below a previous base.
      profileAmounts = amounts.slice().sort(function (a, b) { return a - b; });
      var merchMin = Math.round(merchPrice / 100);
      var below = profileAmounts.filter(function (n) { return n < merchMin; });
      if (below.length) {
        console.error(
          'Pricing profile has ' + below.length + ' price(s) below variant base ' + merchMin + ':',
          below
        );
      }
      var valid = profileAmounts.filter(function (n) { return n >= merchMin; });
      if (!valid.length) {
        hideSupportBox();
        return;
      }
      if (valid.length !== 4) {
        console.error(
          'Pricing profile expected exactly 4 custom prices, got ' + valid.length + ':',
          valid
        );
      }
      // Prefer the profile's own 4 prices. Only when short: prepend base if missing.
      var displayAmounts = valid.slice(0, 4);
      if (valid.length < 4 && displayAmounts.indexOf(merchMin) === -1) {
        displayAmounts.unshift(merchMin);
      }
      // Karibu parity: 2nd button is the suggested amount (1st is the floor).
      // cfg.priceDefaultMin: preselect the floor instead.
      var suggested = !cfg.priceDefaultMin && displayAmounts[1] != null ? displayAmounts[1] : displayAmounts[0];
      tierMax = valid[valid.length - 1];
      var box = form.querySelector('.support-box');
      if (box) box.hidden = false;
      hasPricingProfile = true;
      tiersEl.innerHTML = displayAmounts.map(function (n) {
        return '<button type="button" class="price-btn" data-price-btn="' + n + '">' + formatMajor(n) + '</button>';
      }).join('');
      bindPriceButtons();
      if (slider) {
        slider.min = String(merchMin);
        slider.max = String(tierMax);
        maxTotal = tierMax;
      }
      if (preferSuggested) totalKc = suggested;
      else if (displayAmounts.indexOf(totalKc) === -1) totalKc = suggested;
      syncTotal();
    }

    function applySfMerchPrice(variantId) {
      var gid = String(variantId).indexOf('gid://') === 0 ? String(variantId) : variantGid(variantId);
      if (sfPriceByVariant[gid] == null) return false;
      merchPrice = sfPriceByVariant[gid];
      if (profileAmounts.length) renderTiers(profileAmounts, false);
      else if (slider) {
        var min = Math.round(merchPrice / 100);
        slider.min = String(min);
        if (totalKc < min) totalKc = min;
      } else {
        totalKc = Math.round(merchPrice / 100);
      }
      return true;
    }

    function loadPricingProfile() {
      if (!karibuReady() || !productId) return;
      var ns = cfg.pricingProfileNamespace || '';
      var q = [
        'query($id:ID!,$country:CountryCode!,$language:LanguageCode!,$pricingProfileNamespace:String!)',
        '@inContext(country:$country,language:$language){',
        'product(id:$id){',
        'variants(first:50){edges{node{id price{amount currencyCode}}}}',
        ns
          ? 'pricingProfileMetafield:metafield(namespace:$pricingProfileNamespace,key:"pricing_profile"){reference{...on Metaobject{fields{key references(first:50){edges{node{...on Metaobject{fields{key value}}}}}}}}}'
          : '',
        '}}}'
      ].join('');
      sf(q, { id: productGid(productId), pricingProfileNamespace: ns }).then(function (res) {
        var product = res.data && res.data.product;
        if (!product) return;

        var sfVariants = ((product.variants && product.variants.edges) || []).map(function (e) { return e.node; });
        sfVariants.forEach(function (v) {
          if (v.price && v.price.amount != null) {
            sfPriceByVariant[v.id] = Math.round(parseFloat(v.price.amount) * 100);
          }
        });
        applySfMerchPrice(idInput.value);

        var amounts = [];
        var ref = product.pricingProfileMetafield && product.pricingProfileMetafield.reference;
        if (ref && ref.fields) {
          var pricesField = ref.fields.find(function (f) { return f.key === 'prices'; });
          var edges = (pricesField && pricesField.references && pricesField.references.edges) || [];
          var currency = getLocale().currency;
          amounts = edges.map(function (edge) {
            var fields = (edge.node && edge.node.fields) || [];
            var row = {};
            fields.forEach(function (f) { row[f.key] = f.value; });
            return row;
          }).filter(function (row) {
            return String(row.currency || '').toUpperCase() === currency;
          }).map(function (row) {
            return parseInt(row.amount_major, 10);
          }).filter(function (n) {
            return n > 0;
          }).sort(function (a, b) { return a - b; });
        }

        if (amounts.length) renderTiers(amounts, true);
        else hideSupportBox();
      }).catch(function () { hideSupportBox(); });
    }

    function syncVariant() {
      pruneOptions();
      var variant = findVariant(selectedOptions());
      if (!variant) {
        // ponytail: only after prune failed - never silently buy variants[0] for a missing combo
        variant = variants.find(function (v) { return v.available !== false; }) || variants[0];
        if (variant) {
          optionSelects.forEach(function (sel) {
            var idx = parseInt(sel.dataset.optionIndex, 10);
            if (variant.options[idx] != null) sel.value = String(variant.options[idx]);
          });
          pruneOptions();
        }
      }
      if (variant) {
        idInput.value = variant.id;
        if (!applySfMerchPrice(variant.id)) {
          merchPrice = variant.price;
          if (profileAmounts.length) renderTiers(profileAmounts, false);
          else if (slider) {
            var min = Math.round(merchPrice / 100);
            slider.min = String(min);
            if (totalKc < min) totalKc = min;
          } else {
            totalKc = Math.round(merchPrice / 100);
          }
        }
        if (merchEl) merchEl.textContent = formatMoney(merchPrice);
      }
      syncAddButton(variant);
      syncCutFit(selectedCutFit(optionSelects), variant ? mediaByVariant[variant.id] : '', selectedColor(optionSelects));
      syncTotal();
    }

    function syncTotal() {
      var merchMin = Math.round(merchPrice / 100);
      if (totalKc < merchMin) totalKc = merchMin;
      var donationKc = Math.max(0, totalKc - merchMin);
      // ponytail: DPH 21 % z ceny zboží (včetně DPH) = merch × 21/121
      var taxCents = Math.round(merchPrice * 21 / 121);
      if (totalEl) totalEl.textContent = formatMoney(totalKc * 100);
      if (donationEl) donationEl.textContent = formatMoney(donationKc * 100);
      if (taxEl) taxEl.textContent = formatMoneyDecimals(taxCents);
      if (merchEl) merchEl.textContent = formatMoney(merchPrice);
      if (slider) {
        slider.value = String(totalKc);
        var slideMin = parseInt(slider.min, 10);
        var slideMax = parseInt(slider.max, 10) || totalKc;
        var ratio = slideMax > slideMin ? (totalKc - slideMin) / (slideMax - slideMin) : 0;
        // Thumb travels (w - 28); fill ends at thumb center. At min: no fill (no end-cap peanut).
        var pct = 0;
        if (ratio > 0) {
          var thumb = 28;
          var w = slider.clientWidth;
          pct = w ? ((thumb / 2) + ratio * (w - thumb)) / w * 100 : ratio * 100;
        }
        slider.style.setProperty('--pct', pct + '%');
      }
      priceButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.dataset.priceBtn, 10) === totalKc);
      });
    }

    bindPriceButtons();

    if (slider) {
      slider.addEventListener('input', function () {
        totalKc = parseInt(slider.value, 10);
        syncTotal();
      });
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', syncVariant);
    });

    syncVariant();
    loadPricingProfile();

    // type=button - native product form must never POST to /cart/add (Shopify redirects to cart)
    if (!addBtn) return;

    function addToCart() {
      if (!karibuReady()) {
        alert('Nákup zatím není dostupný.');
        return;
      }
      syncVariant();
      var variant = findVariant(selectedOptions());
      if (!variant || variant.available === false) {
        syncAddButton(variant);
        return;
      }
      addBtn.disabled = true;

      var merchId = parseInt(idInput.value, 10);
      addMerchKaribu(merchId, totalKc)
        .then(function () {
          paintCartBadge(true);
          showToast(addBtn.dataset.addedMsg || 'Přidáno do košíku');
        })
        .catch(function () {
          alert('Nepodařilo se přidat do košíku.');
        })
        .finally(function () { syncAddButton(findVariant(selectedOptions())); });
    }

    addBtn.addEventListener('click', addToCart);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  });

  /* - Product card color cycle on hover - */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('[data-color-cycle]').forEach(function (media) {
      var imgs = media.querySelectorAll('img');
      if (imgs.length < 2) return;
      var i = 0;
      var t = null;
      var exitT = null;
      function reset() {
        clearInterval(t);
        clearTimeout(exitT);
        t = null;
        exitT = null;
        for (var j = 0; j < imgs.length; j++) {
          imgs[j].classList.remove('is-active', 'is-exit');
        }
        i = 0;
        imgs[0].classList.add('is-active');
      }
      function advance() {
        var prev = i;
        imgs[prev].classList.remove('is-active');
        imgs[prev].classList.add('is-exit');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-active');
        clearTimeout(exitT);
        exitT = setTimeout(function () {
          imgs[prev].classList.remove('is-exit');
        }, 450);
      }
      media.addEventListener('mouseenter', function () {
        if (t) return;
        advance();
        t = setInterval(advance, 1500);
      });
      media.addEventListener('mouseleave', reset);
    });
  }

  /* - Product gallery dots (mobile carousel) - */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var wrap = gallery.parentElement;
    if (!wrap) return;
    var dots = wrap.querySelectorAll('[data-gallery-dot]');
    var slides = gallery.querySelectorAll('.product-page__gallery-slide');
    if (!dots.length || !slides.length) return;

    function setActive(i) {
      dots.forEach(function (dot, idx) {
        var on = idx === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function indexFromScroll() {
      var x = gallery.scrollLeft + gallery.clientWidth * 0.15;
      var fallback = 0;
      for (var i = slides.length - 1; i >= 0; i--) {
        if (slides[i].hidden) continue;
        fallback = i;
        if (slides[i].offsetLeft <= x) return i;
      }
      return fallback;
    }

    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(indexFromScroll());
        ticking = false;
      });
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-gallery-dot'), 10);
        var slide = slides[i];
        if (slide && !slide.hidden) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  });

  /* - Ajax cart qty (fallback) - */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var key = wrap.dataset.lineKey;
    if (!key) return;
    function update(qty) {
      qty = Math.max(0, parseInt(qty, 10) || 0);
      input.value = qty;
      var body = { updates: {} };
      body.updates[key] = qty;
      fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function () { window.location.reload(); });
    }
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      update(parseInt(input.value, 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      update(parseInt(input.value, 10) + 1);
    });
    input.addEventListener('change', function () {
      update(input.value);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        input.blur();
      }
    });
  });

  /* - Ajax cart variant (fallback) - */
  document.querySelectorAll('[data-ajax-variant]').forEach(function (wrap) {
    var key = wrap.dataset.lineKey;
    var qty = parseInt(wrap.dataset.qty, 10) || 1;
    var mapEl = wrap.querySelector('[data-variant-map]');
    var propsEl = wrap.querySelector('[data-line-properties]');
    if (!key || !mapEl) return;
    var variants = [];
    var properties = {};
    try { variants = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (propsEl) {
      try { properties = JSON.parse(propsEl.textContent) || {}; } catch (e) { properties = {}; }
    }
    var selects = wrap.querySelectorAll('select[data-option-index]');

    function findVariant() {
      var wanted = [];
      selects.forEach(function (sel) {
        wanted[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      return variants.find(function (v) {
        var opts = v.options || [];
        if (opts.length !== wanted.length) return false;
        return opts.every(function (val, i) { return val === wanted[i]; });
      });
    }

    function apply() {
      var variant = findVariant();
      if (!variant) {
        alert('Tato kombinace velikosti a barvy není dostupná.');
        return;
      }
      if (variant.available === false) {
        alert('Tato varianta není skladem.');
        return;
      }
      var updates = {};
      updates[key] = 0;
      fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: qty, properties: properties }]
          })
        });
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        alert('Variantu se nepodařilo změnit.');
      });
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', apply);
    });
  });

  /* - Karibu cart page - */
  function renderKaribuCart(cart) {
    var page = document.querySelector('[data-karibu-cart-page]');
    if (!page) return;
    var empty = page.querySelector('[data-karibu-empty]');
    var filled = page.querySelector('[data-karibu-filled]');
    var linesEl = page.querySelector('[data-karibu-lines]');
    var lines = lineNodes(cart);
    updateCartBadge(cart);

    if (!cart || !lines.length) {
      if (empty) empty.hidden = false;
      if (filled) filled.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (filled) filled.hidden = false;

    var goods = 0;
    var donation = 0;
    var html = '';
    var variantMaps = {};

    lines.forEach(function (line) {
      var base = baseUnit(line);
      var chosen = chosenUnit(line);
      var qty = line.quantity;
      var goodsLine = base * qty;
      var discLine = lineDiscountAmount(line);
      var donLine = Math.max(0, chosen - base) * qty;
      goods += goodsLine;
      donation += donLine;

      var m = line.merchandise || {};
      var img = (m.image && m.image.url) ? '<img src="' + m.image.url + '" alt="">' : '<span class="cart-line__media-placeholder" aria-hidden="true"></span>';
      var title = (m.product && m.product.title) ? m.product.title : '';
      var handle = m.product && m.product.handle;
      var href = handle ? (root() + 'products/' + handle) : '';
      var mediaHtml = href
        ? '<a class="cart-line__media" href="' + href + '">' + img + '</a>'
        : '<div class="cart-line__media">' + img + '</div>';
      var titleHtml = href
        ? '<a href="' + href + '">' + title + '</a>'
        : title;

      var optionsHtml = '';
      var product = m.product || {};
      var options = (product.options || []).filter(function (o) {
        return !(o.name === 'Title' && (o.values || []).length === 1 && o.values[0] === 'Default Title');
      });
      var selected = {};
      (m.selectedOptions || []).forEach(function (o) { selected[o.name] = o.value; });
      if (options.length) {
        variantMaps[line.id] = ((product.variants && product.variants.edges) || []).map(function (e) { return e.node; });
        optionsHtml = '<div class="cart-line__opts" data-sf-variant data-line-id="' + line.id + '" data-qty="' + qty + '" data-chosen="' + chosen + '">';
        options.forEach(function (opt) {
          optionsHtml +=
            '<label class="cart-line__opt">' +
              '<span>' + opt.name + '</span>' +
              '<select data-option-name="' + opt.name.replace(/"/g, '&quot;') + '">' +
                (opt.values || []).map(function (val) {
                  var sel = selected[opt.name] === val ? ' selected' : '';
                  return '<option value="' + String(val).replace(/"/g, '&quot;') + '"' + sel + '>' + val + '</option>';
                }).join('') +
              '</select>' +
            '</label>';
        });
        optionsHtml += '</div>';
      } else {
        optionsHtml = '<p class="cart-line__meta">' + (m.title || '') + '</p>';
      }

      // original = chosen×qty; final = goods after allocations + undiscountd donation
      var lineOriginal = goodsLine + donLine;
      var lineTotal = lineOriginal - discLine;
      var priceHtml = discLine > 0
        ? (
          '<span class="cart-line__price-was">' + moneyFromAmount(lineOriginal) + '</span>' +
          '<span class="cart-line__discount">−' + moneyFromAmount(discLine) + '</span>' +
          '<span class="cart-line__price-now">' + moneyFromAmount(lineTotal) + '</span>'
        )
        : moneyFromAmount(lineTotal);
      html +=
        '<div class="cart-line" data-sf-line="' + line.id + '">' +
          mediaHtml +
          '<div class="cart-line__info">' +
            '<p class="cart-line__title">' + titleHtml + '</p>' +
            optionsHtml +
            '<div class="qty" data-sf-qty data-line-id="' + line.id + '">' +
              '<button type="button" data-qty-minus aria-label="−">−</button>' +
              '<input type="number" value="' + qty + '" min="0" inputmode="numeric" aria-label="Počet">' +
              '<button type="button" data-qty-plus aria-label="+">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-line__price">' + priceHtml + '</div>' +
        '</div>';
    });

    linesEl.innerHTML = html;

    // ponytail: sleva = sum Shopify LINE_ITEM allocations; dar z chosen_price se neslevňuje
    var discountRows = discountRowsFromLines(lines);
    var discount = discountRows.reduce(function (s, r) { return s + r.amount; }, 0);
    var merchAfterDiscount = Math.max(0, goods - discount);
    // ponytail: flat 99 Kč per order, same figure as the product note. Not per item.
    var shippingEl = page.querySelector('[data-karibu-shipping]');
    var shipping = shippingEl ? (parseFloat(shippingEl.dataset.shippingAmount) || 0) : 0;
    var total = merchAfterDiscount + donation + shipping;
    var vat21 = Math.round((merchAfterDiscount + shipping) * 21 / 121 * 100) / 100;
    var totalEl = page.querySelector('[data-karibu-total]');
    var goodsEl = page.querySelector('[data-karibu-goods]');
    var donEl = page.querySelector('[data-karibu-donation]');
    var vatEl = page.querySelector('[data-karibu-vat]');
    var vat12El = page.querySelector('[data-karibu-vat12]');
    var discountRowsEl = page.querySelector('[data-karibu-discount-rows]');
    if (totalEl) totalEl.textContent = moneyFromAmount(total);
    if (goodsEl) goodsEl.textContent = moneyFromAmount(goods);
    if (donEl) donEl.textContent = moneyFromAmount(donation);
    if (shippingEl) shippingEl.textContent = moneyFromAmount(shipping);
    if (vatEl) vatEl.textContent = moneyFromAmount(vat21);
    if (vat12El) vat12El.textContent = moneyFromAmount(0);
    if (discountRowsEl) {
      var discLabel = discountRowsEl.dataset.discountLabel || 'Sleva';
      discountRowsEl.innerHTML = discountRows.map(function (row) {
        var label = row.label === discLabel || row.label === 'Sleva' || row.label === 'Discount'
          ? discLabel
          : discLabel + ' · ' + row.label;
        return '<div class="cart-recap__row cart-recap__row--discount"><span>' + escapeText(label) + '</span><span>−' + moneyFromAmount(row.amount) + '</span></div>';
      }).join('');
    }

    bindSfQty(cart.id);
    bindSfVariant(cart.id, variantMaps);
    bindSfDiscount(cart.id, cart);
  }

  function bindSfVariant(cartId, variantMaps) {
    document.querySelectorAll('[data-sf-variant]').forEach(function (wrap) {
      var lineId = wrap.dataset.lineId;
      var qty = parseInt(wrap.dataset.qty, 10) || 1;
      var chosen = parseFloat(wrap.dataset.chosen) || 0;
      var variants = (variantMaps && variantMaps[lineId]) || [];
      var selects = wrap.querySelectorAll('select[data-option-name]');
      if (!variants.length || !selects.length) return;

      function findVariant() {
        var wanted = {};
        selects.forEach(function (sel) { wanted[sel.getAttribute('data-option-name')] = sel.value; });
        return variants.find(function (v) {
          var opts = v.selectedOptions || [];
          return opts.length === Object.keys(wanted).length &&
            opts.every(function (o) { return wanted[o.name] === o.value; });
        });
      }

      function apply() {
        var variant = findVariant();
        if (!variant || !variant.id) {
          alert('Tato kombinace velikosti a barvy není dostupná.');
          return;
        }
        if (variant.availableForSale === false) {
          alert('Tato varianta není skladem.');
          return;
        }
        cartLinesUpdate(cartId, [{
          id: lineId,
          merchandiseId: variant.id,
          quantity: qty,
          attributes: [{ key: 'karibu_chosen_price', value: Number(chosen).toFixed(2) }]
        }]).then(function (next) {
          renderKaribuCart(next);
        }).catch(function () {
          alert('Variantu se nepodařilo změnit.');
        });
      }

      selects.forEach(function (sel) { sel.onchange = apply; });
    });
  }

  function bindSfDiscount(cartId, cart) {
    var wrap = document.querySelector('[data-karibu-discount-form]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-discount-input]');
    var btn = wrap.querySelector('[data-discount-apply]');
    var errEl = wrap.querySelector('[data-discount-error]');
    var listEl = wrap.querySelector('[data-discount-codes]');
    var invalidMsg = wrap.dataset.msgInvalid || 'Slevový kód není platný.';
    var alreadyMsg = wrap.dataset.msgAlready || 'Tento kód už je na košíku.';
    var inactiveMsg = wrap.dataset.msgInactive || 'Na tento košík se nevztahuje.';
    var codes = (cart && cart.discountCodes) || [];

    if (listEl) {
      if (!codes.length) {
        listEl.hidden = true;
        listEl.innerHTML = '';
      } else {
        listEl.hidden = false;
        listEl.innerHTML = codes.map(function (entry) {
          var status = entry.applicable ? '' : '<span class="cart-discount__status">' + escapeText(inactiveMsg) + '</span>';
          return (
            '<li class="cart-discount__code' + (entry.applicable ? '' : ' is-inactive') + '">' +
              '<span class="cart-discount__code-name">' + escapeText(entry.code) + '</span>' +
              status +
              '<button type="button" class="cart-discount__remove" data-remove-code="' + escapeText(entry.code) + '" aria-label="×">&times;</button>' +
            '</li>'
          );
        }).join('');
      }
    }

    if (input && document.activeElement !== input) input.value = '';

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function setBusy(busy) {
      if (btn) btn.disabled = busy;
      if (input) input.disabled = busy;
      wrap.querySelectorAll('[data-remove-code]').forEach(function (el) { el.disabled = busy; });
    }

    function applyCodes(nextCodes, addedCode) {
      setBusy(true);
      showError('');
      cartDiscountCodesUpdate(cartId, nextCodes)
        .then(function (result) {
          var next = result.cart;
          var warning = discountWarning(result.warnings);
          var accepted = appliedDiscountCodes(next).map(function (c) { return c.toLowerCase(); });
          if (addedCode && accepted.indexOf(addedCode.toLowerCase()) === -1) {
            showError(warning ? warning.message : invalidMsg);
          } else if (warning) {
            showError(warning.message);
          }
          if (addedCode && input) input.value = '';
          renderKaribuCart(next);
        })
        .catch(function (err) {
          showError((err && err.message) || invalidMsg);
        })
        .finally(function () {
          setBusy(false);
        });
    }

    function apply() {
      var code = (input && input.value || '').trim();
      if (!code) return;
      var existing = appliedDiscountCodes(cart);
      if (existing.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        showError(alreadyMsg);
        return;
      }
      // Shopify replaces the whole set - keep existing + add new
      applyCodes(existing.concat([code]), code);
    }

    if (btn) btn.onclick = apply;
    if (input) {
      input.onkeydown = function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          apply();
        }
      };
    }
    wrap.querySelectorAll('[data-remove-code]').forEach(function (el) {
      el.onclick = function () {
        var code = el.getAttribute('data-remove-code');
        applyCodes(appliedDiscountCodes(cart).filter(function (c) { return c !== code; }), null);
      };
    });
  }

  function bindSfQty(cartId) {
    document.querySelectorAll('[data-sf-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var lineId = wrap.dataset.lineId;
      function update(qty) {
        qty = Math.max(0, parseInt(qty, 10) || 0);
        // karibu_chosen_price stays on the line → +1 qty adds merch + dar
        cartLinesUpdate(cartId, [{ id: lineId, quantity: qty }])
          .then(function (cart) {
            renderKaribuCart(cart);
          })
          .catch(function () {
            alert('Počet se nepodařilo změnit.');
          });
      }
      wrap.querySelector('[data-qty-minus]').onclick = function () {
        update(parseInt(input.value, 10) - 1);
      };
      wrap.querySelector('[data-qty-plus]').onclick = function () {
        update(parseInt(input.value, 10) + 1);
      };
      input.onchange = function () { update(input.value); };
    });
  }

  if (karibuReady() && document.querySelector('[data-karibu-cart-page]')) {
    // paint from session cache immediately; revalidate in background
    var cached = readCartCache();
    if (cached) renderKaribuCart(cached);
    ensureCart().then(renderKaribuCart).catch(function () {
      if (!cached) renderKaribuCart(null);
    });
  }
  // ponytail: badge trusts localStorage (html.mch-has-cart in <head>); no ensureCart on every page

  /* - Checkout - */
  var checkoutForm = document.querySelector('[data-checkout-form]');
  if (checkoutForm) {
    var VALID = {
      fill: checkoutForm.dataset.msgFill || 'Vyplňte pole',
      email: checkoutForm.dataset.msgEmail || 'Zadejte platnou e-mailovou adresu.',
      phoneFmt: checkoutForm.dataset.msgPhone || 'Zadejte platné telefonní číslo (9 číslic).',
      checkbox: checkoutForm.dataset.msgCheckbox || 'Zaškrtněte souhlas s obchodními podmínkami.',
      heading: checkoutForm.dataset.msgHeading || 'Chyby formuláře:',
      fullName: checkoutForm.dataset.labelFullName || 'Jméno a příjmení',
      phone: checkoutForm.dataset.labelPhone || 'Telefon',
      purchase: checkoutForm.dataset.secPurchase || 'Nákup',
      donation: checkoutForm.dataset.secDonation || 'Dar',
      company: checkoutForm.dataset.secCompany || 'Firma'
    };
    var errorsBox = checkoutForm.querySelector('[data-form-errors]');

    var DIAL = { CZ: '+420', SK: '+421', 'Česká republika': '+420', 'Slovensko': '+421' };
    // ponytail: CZ/SK only - 9 national digits; upgrade to libphonenumber-js if more countries
    function toE164(raw) {
      var d = String(raw || '').replace(/\D/g, '');
      return d ? '+' + d : '';
    }
    function formatPhone(raw, dial) {
      dial = dial || '+420';
      var rest = String(raw || '').replace(/\D/g, '');
      var dialDigits = dial.replace(/\D/g, '');
      if (rest.indexOf(dialDigits) === 0) rest = rest.slice(dialDigits.length);
      rest = rest.slice(0, 9);
      if (!rest) return dial;
      var out = dial;
      for (var i = 0; i < rest.length; i += 3) out += ' ' + rest.slice(i, i + 3);
      return out;
    }
    function phoneOk(raw, dial) {
      dial = dial || '+420';
      var dialDigits = dial.replace(/\D/g, '');
      var digits = String(raw || '').replace(/\D/g, '');
      return digits.indexOf(dialDigits) === 0 && digits.length === dialDigits.length + 9;
    }
    function bindPhoneDial(countryEl, phoneEl) {
      if (!countryEl || !phoneEl) return;
      function dialOf() { return phoneEl.getAttribute('data-dial') || '+420'; }
      function nationalOf(raw, dial) {
        var dialDigits = dial.replace(/\D/g, '');
        var digits = String(raw || '').replace(/\D/g, '');
        if (digits.indexOf(dialDigits) === 0) return digits.slice(dialDigits.length).slice(0, 9);
        return (phoneEl.getAttribute('data-national') || '').slice(0, 9);
      }
      function paint(rest, digitsBefore) {
        var dial = dialOf();
        rest = String(rest || '').replace(/\D/g, '').slice(0, 9);
        phoneEl.setAttribute('data-national', rest);
        phoneEl.value = formatPhone(dial + rest, dial);
        var dialDigitsLen = dial.replace(/\D/g, '').length;
        if (digitsBefore == null) digitsBefore = dialDigitsLen + rest.length;
        if (digitsBefore < dialDigitsLen) digitsBefore = dialDigitsLen;
        var count = 0, pos = phoneEl.value.length;
        for (var i = 0; i < phoneEl.value.length; i++) {
          if (/\d/.test(phoneEl.value[i])) count++;
          if (count >= digitsBefore) { pos = i + 1; break; }
        }
        try { phoneEl.setSelectionRange(pos, pos); } catch (err) {}
      }
      function syncPhoneDial() {
        var next = DIAL[countryEl.value] || '+420';
        var prev = dialOf();
        var rest = nationalOf(phoneEl.value, prev);
        phoneEl.placeholder = next;
        phoneEl.setAttribute('data-dial', next);
        paint(rest);
      }
      phoneEl.addEventListener('keydown', function (e) {
        var dial = dialOf();
        var start = phoneEl.selectionStart || 0;
        var end = phoneEl.selectionEnd || 0;
        var min = dial.length;
        if (phoneEl.value.charAt(min) === ' ') min++;
        if (start < min && end <= min && (e.key === 'Backspace' || e.key === 'Delete')) {
          e.preventDefault();
          return;
        }
        if (start < min && (e.key === 'Backspace' || e.key === 'Delete' || e.key.length === 1)) {
          phoneEl.setSelectionRange(Math.max(start, min), Math.max(end, min));
        }
      });
      phoneEl.addEventListener('input', function () {
        var dial = dialOf();
        var dialDigitsLen = dial.replace(/\D/g, '').length;
        var sel = phoneEl.selectionStart || 0;
        var digitsBefore = phoneEl.value.slice(0, sel).replace(/\D/g, '').length;
        paint(nationalOf(phoneEl.value, dial), Math.max(digitsBefore, dialDigitsLen));
      });
      countryEl.addEventListener('change', syncPhoneDial);
      syncPhoneDial();
    }
    bindPhoneDial(checkoutForm.querySelector('#cart-country'), checkoutForm.querySelector('#cart-phone'));
    bindPhoneDial(checkoutForm.querySelector('#dar-country'), checkoutForm.querySelector('#dar-phone'));

    var sameAsDelivery = checkoutForm.querySelector('[data-same-as-delivery]');
    var confirmationFields = checkoutForm.querySelector('[data-confirmation-fields]');
    function syncConfirmationFields() {
      if (!sameAsDelivery || !confirmationFields) return;
      var same = sameAsDelivery.checked;
      confirmationFields.hidden = same;
      confirmationFields.querySelectorAll('input, select').forEach(function (el) {
        el.disabled = same;
        if (/^dar_(jmeno|prijmeni|ulice|mesto|psc|telefon)$/.test(el.name)) el.required = !same;
      });
    }
    if (sameAsDelivery) {
      sameAsDelivery.addEventListener('change', syncConfirmationFields);
      syncConfirmationFields();
    }

    var companyToggle = checkoutForm.querySelector('[data-company-toggle]');
    var companyFields = checkoutForm.querySelector('[data-company-fields]');
    function syncCompanyFields() {
      if (!companyToggle || !companyFields) return;
      var on = companyToggle.checked;
      companyFields.hidden = !on;
      companyFields.querySelectorAll('input').forEach(function (el) {
        el.disabled = !on;
        if (el.name === 'firma' || el.name === 'ico') el.required = on;
      });
    }
    if (companyToggle) {
      companyToggle.addEventListener('change', syncCompanyFields);
      syncCompanyFields();
    }

    var payBtn = checkoutForm.querySelector('[type="submit"]');
    function syncPayBtn() {
      if (payBtn) payBtn.disabled = false;
    }
    function fieldLabel(el) {
      if (el.name === 'telefon' || el.name === 'dar_telefon') return VALID.phone;
      return (el.getAttribute('data-error-label') || el.placeholder || el.getAttribute('aria-label') || el.name || '').trim();
    }
    function sectionOf(el) {
      var n = el.name || '';
      if (/^dar_/.test(n)) return VALID.donation;
      if (n === 'firma' || n === 'ico' || n === 'dic') return VALID.company;
      if (n === 'terms') return '';
      return VALID.purchase;
    }
    function fillMsg(label, el) {
      var msg = VALID.fill + ' „' + label + '“.';
      var sec = el ? sectionOf(el) : '';
      return sec ? sec + ': ' + msg : msg;
    }
    function withSec(el, msg) {
      var sec = sectionOf(el);
      return sec ? sec + ': ' + msg : msg;
    }
    function fieldMissing(el) {
      if (el.disabled) return false;
      if (el.type === 'checkbox' || el.type === 'radio') return !el.checked;
      var v = (el.value || '').trim();
      var dial = el.getAttribute('data-dial');
      if (dial) {
        var digits = v.replace(/\D/g, '');
        if (!digits || digits === dial.replace(/\D/g, '')) return true;
        if (!phoneOk(v, dial)) return 'phone';
      } else if (!v) return true;
      if (el.type === 'email' && el.validity && el.validity.typeMismatch) return 'email';
      return false;
    }
    function pairBothMissing(a, b) {
      return a && b && !a.disabled && !b.disabled && fieldMissing(a) === true && fieldMissing(b) === true;
    }
    function checkoutErrors() {
      var msgs = [];
      var skip = {};
      var PAIR = { jmeno: 'prijmeni', prijmeni: 'jmeno', dar_jmeno: 'dar_prijmeni', dar_prijmeni: 'dar_jmeno' };
      var els = checkoutForm.querySelectorAll('input[required], select[required], textarea[required]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (skip[el.name]) continue;
        var miss = fieldMissing(el);
        if (!miss) continue;
        var otherName = PAIR[el.name];
        if (otherName) {
          var other = checkoutForm.querySelector('[name="' + otherName + '"]');
          if (pairBothMissing(el, other)) {
            msgs.push(fillMsg(VALID.fullName, el));
            skip[el.name] = skip[otherName] = true;
            continue;
          }
        }
        if (el.type === 'checkbox') msgs.push(VALID.checkbox);
        else if (miss === 'email') msgs.push(withSec(el, VALID.email));
        else if (miss === 'phone') msgs.push(withSec(el, VALID.phoneFmt));
        else msgs.push(fillMsg(fieldLabel(el), el));
      }
      return msgs;
    }
    // ponytail: list stays until next submit - live input used to wipe it and jump the footer
    function showFormErrors(msgs) {
      if (!errorsBox) return;
      errorsBox.replaceChildren();
      if (!msgs.length) {
        errorsBox.hidden = true;
        return;
      }
      var title = document.createElement('p');
      title.className = 'form-errors__title';
      title.textContent = VALID.heading.indexOf('Translation missing') === 0 ? 'Chyby formuláře:' : VALID.heading;
      var ul = document.createElement('ul');
      msgs.forEach(function (m) {
        var li = document.createElement('li');
        li.textContent = m;
        ul.appendChild(li);
      });
      errorsBox.appendChild(title);
      errorsBox.appendChild(ul);
      errorsBox.hidden = false;
    }

    checkoutForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (payBtn && payBtn.disabled) return;
      var msgs = checkoutErrors();
      if (msgs.length) {
        showFormErrors(msgs);
        errorsBox.scrollIntoView({ block: 'nearest' });
        return;
      }
      showFormErrors([]);

      if (!karibuReady() || !checkoutForm.hasAttribute('data-karibu-checkout')) {
        alert('Nákup zatím není dostupný.');
        return;
      }

      var cartId = getCartId();
      if (!cartId) {
        alert('Košík je prázdný.');
        return;
      }
      var btn = e.submitter || checkoutForm.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      var contactEmail = val(checkoutForm, 'email');
      var shippingName = (val(checkoutForm, 'jmeno') + ' ' + val(checkoutForm, 'prijmeni')).trim();
      var shipping = {
        email: contactEmail,
        name: shippingName,
        address: {
          street: val(checkoutForm, 'ulice'),
          city: val(checkoutForm, 'mesto'),
          postcode: val(checkoutForm, 'psc'),
          country: val(checkoutForm, 'zeme') || getLocale().country
        },
        phone: toE164(val(checkoutForm, 'telefon')) || null,
        ico: null,
        dic: null
      };

      var same = !sameAsDelivery || sameAsDelivery.checked;
      var companyDonation = companyToggle && companyToggle.checked;
      var ico = companyDonation ? (val(checkoutForm, 'ico') || null) : null;
      var dic = companyDonation ? (val(checkoutForm, 'dic') || null) : null;
      var firma = companyDonation ? val(checkoutForm, 'firma') : '';
      var billing;
      if (same) {
        billing = {
          email: contactEmail,
          name: firma || shippingName,
          address: shipping.address,
          phone: shipping.phone,
          ico: ico,
          dic: dic
        };
      } else {
        var darName = (val(checkoutForm, 'dar_jmeno') + ' ' + val(checkoutForm, 'dar_prijmeni')).trim();
        var darEmail = val(checkoutForm, 'dar_email');
        var darPhone = toE164(val(checkoutForm, 'dar_telefon'));
        billing = {
          email: darEmail || contactEmail,
          name: darName || firma || shippingName,
          address: {
            street: val(checkoutForm, 'dar_ulice'),
            city: val(checkoutForm, 'dar_mesto'),
            postcode: val(checkoutForm, 'dar_psc'),
            country: val(checkoutForm, 'dar_zeme') || getLocale().country
          },
          phone: darPhone || shipping.phone || null,
          ico: ico,
          dic: dic
        };
      }

      var newsletterEl = checkoutForm.querySelector('[name="newsletter"]');
      var body = {
        paymentMethod: 'PAYMENT_GATEWAY',
        cartId: cartId,
        billing: billing,
        shipping: shipping,
        newsletter: !!(newsletterEl && newsletterEl.checked)
      };

      if (!same || companyDonation) {
        body.donationAcknowledgement = {
          email: billing.email,
          name: billing.name,
          address: billing.address,
          phone: billing.phone,
          ico: ico,
          dic: dic
        };
      }

      var base = String(cfg.karibuApiBase).replace(/\/$/, '');
      fetch(base + '/v1/tenants/' + encodeURIComponent(cfg.karibuTenant) + '/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, status: r.status, data: data };
          });
        })
        .then(function (res) {
          if (res.ok && res.data && res.data.message) {
            setCartId('');
            window.location.href = res.data.message;
            return;
          }
          syncPayBtn();
          console.warn('Karibu checkout', res.status, res.data);
          alert('Objednávku se nepodařilo založit. Zkuste to prosím znovu.');
        })
        .catch(function () {
          syncPayBtn();
          alert('Objednávku se nepodařilo založit. Zkuste to prosím znovu.');
        });
    });
  }

  /* Homepage pagination - keep scroll position across ?page= */
  (function () {
    var nav = document.querySelector('.template-index .pagination');
    if (!nav) return;
    nav.addEventListener('click', function (e) {
      if (!e.target.closest('a[href]')) return;
      try { sessionStorage.setItem('mch_home_scroll', String(window.scrollY)); } catch (err) {}
    });
  })();

  /* Cookie banner → Shopify Customer Privacy. Optional categories stay off until consent. */
  (function () {
    var root = document.getElementById('mch-cookie');
    if (!root) return;
    var banner = root.querySelector('[data-mch-cookie-view="banner"]');
    var settings = root.querySelector('[data-mch-cookie-view="settings"]');

    function show(view) {
      banner.hidden = view !== 'banner';
      settings.hidden = view !== 'settings';
      root.hidden = false;
    }
    function hide() {
      root.hidden = true;
    }
    function optionalBox() {
      return settings.querySelector('[data-mch-consent="optional"]');
    }
    function consent(on) {
      return { analytics: on, marketing: on, preferences: on };
    }
    var pending = null;
    function fill() {
      var current = (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.currentVisitorConsent()) || {};
      optionalBox().checked = current.analytics === 'yes';
    }
    function save(consent) {
      pending = consent;
      if (!window.Shopify || !Shopify.customerPrivacy) return;
      Shopify.customerPrivacy.setTrackingConsent(consent, function (result) {
        if (result && result.error) return;
        pending = null;
        hide();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mch-cookie-open]')) {
        e.preventDefault();
        fill();
        show('settings');
        return;
      }
      var btn = e.target.closest('[data-mch-cookie]');
      if (!btn || !root.contains(btn)) return;
      var action = btn.getAttribute('data-mch-cookie');
      if (action === 'settings') {
        fill();
        show('settings');
      } else if (action === 'deny') {
        save(consent(false));
      } else if (action === 'accept') {
        save(consent(true));
      } else if (action === 'save') {
        save(consent(optionalBox().checked));
      }
    });

    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !Shopify.customerPrivacy) return;
      if (pending) {
        save(pending);
        return;
      }
      var current = Shopify.customerPrivacy.currentVisitorConsent() || {};
      var answered = current.analytics === 'yes' || current.analytics === 'no';
      if (Shopify.customerPrivacy.shouldShowBanner() && !answered) show('banner');
    });
  })();
})();
